import styled from 'styled-components';

// @todo: ajustar responsividade
export const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 12% 0 4% 15.625%;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1024px) {
    margin: 20% 0 0 0;
  }

  @media (max-width: 960px) {
    margin: 26% 0 0 0;
  }
`;

export const ButtonContainer = styled.div`
  width: 400px;
  margin: 2% 0;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 960px) {
    width: 100%;
    padding: 1rem 20%;
  }
`;

export const Paragraph = styled.p`
  font-size: 1.125rem;
  font-weight: 300;
  color: #6c677a;
  text-align: right;
  margin-right: 22px;

  @media (max-width: 1024px) {
    margin-bottom: 5%;
    font-size: 2.2rem;
  }

  @media (max-width: 960px) {
    margin-bottom: 5%;
    font-size: 1.2rem;
    margin-right: 0;
  }
`;

export const Span = styled.span`
  font-size: 1.125rem;
  font-weight: 100;
  color: #ffffff;
  opacity: 0.6;
  line-height: 1.5rem;
  margin-top: 2%;
  width: 75%;

  @media (max-width: 1024px) {
    margin: 5% 15% 0 15%;
    font-size: 3.5vw;
    line-height: 2.2rem;
  }

  @media (max-width: 960px) {
    margin: 5% 15% 0 15%;
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
`;

export const Small = styled.small`
  font-size: 1.025rem;
  font-weight: 100;
  color: #ffffff;
  opacity: 0.6;
  line-height: 1rem;
  width: 75%;

  @media (max-width: 1024px) {
    margin: 5% 15% 0 15%;
    font-size: 3.5vw;
    line-height: 2.2rem;
  }

  @media (max-width: 960px) {
    margin: 5% 15% 0 15%;
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
`;

export const AlertImage = styled.img`
  width: 10%;

  @media (max-width: 1024px) {
    margin-top: 5%;
    width: 10%;
  }

  @media (max-width: 960px) {
    margin-top: 5%;
    width: 15%;
    align-self: center;
  }
`;
